<template>
  <div class="my-schedule m-3">
    <nav class="nav nav-tabs nav-justified flex-nowrap" v-if="doctorClinics.length > 1">
      <a
        href="#"
        class="nav-item nav-link py-3 text-left text-center service-item"
        v-for="c of doctorClinics"
        :key="c"
        :class="{active: selectedClinic === c}"
        @click.prevent="selectedClinic = c">
        {{clinicById(c).name[authLocale]}}
        <!-- {{clinicById(c).city_id}}
        {{clinicById(c).address[authLocale]}} -->
      </a>
    </nav>
    <nav class="nav nav-tabs nav-justified flex-nowrap">
      <a
        href="#"
        class="nav-item nav-link py-3 text-left text-center service-item"
        v-for="s of clinicServiceList"
        :key="s.id"
        :class="{active: selectedServiceIndex === s.index}"
        @click.prevent="selectedServiceIndex = s.index">
        <template v-if="s.service_id">
          <online-consultation-icon
            v-if="s.type === 'telemedicine'"
          ></online-consultation-icon>
          <clinic-icon v-else-if="s.type === 'visit'"></clinic-icon>
          <ambulance-icon
            v-else-if="s.type === 'house_call'"
          ></ambulance-icon>
          <span class="ml-2">
            {{ $t(s.type) }}
            {{ s.name[authLocale] }}
            {{ Math.round(s.price / 100).toFixed(2) }} ₾
          </span>
          <span v-if="s.name_addition">
            ({{ s.name_addition[authLocale] }})
          </span>
        </template>
      </a>
    </nav>
    <div class="border-left border-right border-bottom">
      <div class="dates m-3">
        <div class="py-2 px-3 row no-gutters">
          <div class="col-auto first">
            <a class="pointer" @click.prevent="first" v-if="index !== 0">
              <double-arrow-icon></double-arrow-icon>
            </a>
          </div>
          <div class="col-auto prev">
            <a class="pointer" @click.prevent="prev" v-if="index !== 0">
              <angle-icon></angle-icon>
            </a>
          </div>
          <div class="col text-center">
            <template v-if="dates[index]">
              <strong>{{ dates[index] | moment("DD MMMM, dddd") }}</strong>
            </template>
          </div>
          <div class="col-auto next">
            <a
              class="pointer"
              @click.prevent="next"
              v-if="index !== dates.length - 1"
            >
              <angle-icon></angle-icon>
            </a>
          </div>
        </div>
      </div>
      <div class="times m-3">
        <div class="p-3 row no-gutters" v-if="service">
          <div
            class="col-auto text-center border mb-2 mx-2 py-2 rounded"
            style="width: 75px; user-select: none;"
            @click.exact="select(index)"
            @click.shift="selectShift(index)"
            v-for="(t,index) of times"
            :key="t"
            :class="{
              'bg-primary text-white': selected.includes(index),
              'bg-warning': saved.includes(t)
            }"
          >
            <small class="py-3 px-2 pointer">{{ t }}</small>
          </div>
        </div>
        <button
          class="btn btn-outline-primary btn-block"
          @click="save"
          :class="{ disabled: selected.length === 0 }"
        >
          დამახსოვრება
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import AngleIcon from '@/components/Icons/Angle'
import DoubleArrowIcon from '@/components/Icons/DoubleArrow'
import OnlineConsultationIcon from '@/components/Icons/OnlineConsultation'
import ClinicIcon from '@/components/Icons/Clinic'
import AmbulanceIcon from '@/components/Icons/Ambulance'
import { mapMutations, mapGetters } from 'vuex'
export default {
  components: {
    AngleIcon,
    DoubleArrowIcon,
    OnlineConsultationIcon,
    ClinicIcon,
    AmbulanceIcon
  },
  props: {
    doctorId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      clinics: [],
      services: [],
      index: 0,
      dates: [],
      step: 30,
      times: [],
      selected: [],
      selectedServiceIndex: 0,
      saved: [],
      selectedClinic: null
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale'
    }),
    doctorClinics () {
      const clinics = {}
      for (const service of this.services) {
        clinics[service.clinic_id] = service.clinic_id
      }
      return Object.values(clinics)
    },
    clinicServiceList () {
      const ret = []
      for (const i in this.services) {
        const s = this.services[i]
        if (s.clinic_id === this.selectedClinic) {
          s.index = i
          ret.push(s)
        }
      }
      return ret
    },
    service () {
      return this.services[this.selectedServiceIndex]
    },
    selectedDate () {
      return this.dates[this.index]
    },
    selectedTime () {
      return this.selected[this.dates[this.index]]
    }
  },
  watch: {
    doctorId (val) {
      this.init()
    },
    selectedClinic () {
      this.selectedServiceIndex = this.clinicServiceList[0].index
    },
    index (val) {
      this.setSaved(this.dates[val])
      this.fetch(() => {
        this.times = []
        for (let i = 0; i < 1440; i += this.step) {
          let hour = '' + Math.floor(i / 60)
          let min = '' + (i % 60)
          if (hour.length === 1) {
            hour = '0' + hour
          }
          if (min.length === 1) {
            min = '0' + min
          }
          this.times.push(`${hour}:${min}`)
        }
      })
    },
    selectedServiceIndex (val) {
      this.step = this.services[val].duration
      this.setSaved(this.selectedDate)
      this.fetch(() => {
        this.times = []
        for (let i = 0; i < 1440; i += this.step) {
          let hour = '' + Math.floor(i / 60)
          let min = '' + (i % 60)
          if (hour.length === 1) {
            hour = '0' + hour
          }
          if (min.length === 1) {
            min = '0' + min
          }
          this.times.push(`${hour}:${min}`)
        }
      })
    },
    step (val) {
      this.times = []
      for (let i = 0; i < 1440; i += val) {
        let hour = '' + Math.floor(i / 60)
        let min = '' + (i % 60)
        if (hour.length === 1) {
          hour = '0' + hour
        }
        if (min.length === 1) {
          min = '0' + min
        }
        this.times.push(`${hour}:${min}`)
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError'
    }),
    init () {
      this.index = 0
      this.selected = []
      this.selectedServiceIndex = 0
      this.saved = []
      this.fetchClinics(() => {
        this.fetch(() => {
          this.times = []
          for (let i = 0; i < 1440; i += this.step) {
            let hour = '' + Math.floor(i / 60)
            let min = '' + (i % 60)
            if (hour.length === 1) {
              hour = '0' + hour
            }
            if (min.length === 1) {
              min = '0' + min
            }
            this.times.push(`${hour}:${min}`)
          }
        })
      })
      this.dates = []
      for (let i = 1; i < 30; i++) {
        this.dates.push(this.$moment().add(i, 'days'))
      }
    },
    async fetch (callback) {
      try {
        const response = await this.axios.get(
          `/api/doctors/${this.doctorId}/availability`
        )
        this.services = response.data.data
        this.selectedClinic = this.service.clinic_id
        this.step = this.service.duration
        if (callback) {
          callback()
        }
        this.setSaved(this.dates[this.index])
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchClinics (cb) {
      try {
        const params = {
          offset: 0,
          limit: 1000
        }
        const response = await this.axios.get(
          '/api/clinics',
          { params }
        )
        this.clinics = response.data.data
        cb()
      } catch (err) {
        this.setError(err)
      }
    },
    setSaved (date) {
      this.saved = []
      if (!this.service.availability) {
        return
      }
      const times = this.service.availability[date.format('YYYY-MM-DD')]
      if (!times || times.length === 0) {
        return
      }
      for (const t of times) {
        const from = this.$moment(t.from).format('HH:mm')
        const to = this.$moment(t.to).format('HH:mm')
        // console.log('from', from.format('H'), from.format('m'))
        // console.log('to', to.format('H'), to.format('m'))
        let found = false
        for (const time of this.times) {
          if (time === from) {
            found = true
          }
          if (time === to) {
            found = false
          }
          if (found) {
            this.saved.push(time)
          }
        }
      }
    },
    clinicById (id) {
      let ret = null
      for (const c of this.clinics) {
        if (c.id === id) {
          ret = c
        }
      }
      return ret
    },
    select (time) {
      const selIndex = this.selected.indexOf(time)
      if (selIndex !== -1) {
        this.selected.splice(selIndex, 1)
      } else {
        this.selected.push(time)
      }
    },
    selectShift (index) {
      const lastItem = this.selected[this.selected.length - 1]
      if (!lastItem) { return }
      for (let i = lastItem + 1; i <= index; i++) {
        // console.log(i)
        this.select(i)
      }
    },
    check () {
      if (this.selected.length > 0) {
        return confirm(
          'გადართვის შემთხვევაში დაგეკარგებათ შეყვანილი ინფორმაცია, ნამდვილად გსურთ გადართვა?'
        )
      }
      return true
    },
    first () {
      if (this.check()) {
        this.selected = []
        this.index = 0
      }
    },
    prev () {
      if (this.check()) {
        this.selected = []
        this.index--
      }
    },
    next () {
      if (this.check()) {
        this.selected = []
        this.index++
      }
    },
    async save () {
      this.selected.sort((a, b) => a - b)
      const ranges = []
      let start = null
      let end = null
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i] + 1 === this.selected[i + 1]) {
          if (start === null) {
            start = this.selected[i]
          }
          end = this.selected[i + 1] + 1
        } else {
          if (start === null && ranges.length === 0) {
            start = this.selected[i]
            end = this.selected[i] + 1
          }
          ranges.push({ start: start, end: end })
          start = null
          end = null
        }
      }
      for (const d of ranges) {
        let startHour = '' + Math.floor((d.start * this.step) / 60)
        let startMin = '' + ((d.start * this.step) % 60)
        let endHour = '' + Math.floor((d.end * this.step) / 60)
        let endMin = '' + ((d.end * this.step) % 60)
        if (startHour.length === 1) {
          startHour = '0' + startHour
        }
        if (endHour.length === 1) {
          endHour = '0' + endHour
        }
        if (startMin.length === 1) {
          startMin = '0' + startMin
        }
        if (endMin.length === 1) {
          endMin = '0' + endMin
        }
        try {
          const params = {
            clinic_service_id: this.service.id,
            starts_at: this.$moment(this.dates[this.index].format('YYYY-MM-DD') + ' ' + startHour + ':' + startMin).format(),
            ends_at: this.$moment(this.dates[this.index].format('YYYY-MM-DD') + ' ' + endHour + ':' + endMin).format()
          }
          await this.axios.post(
            `/api/doctors/${this.doctorId}/availability`,
            params
          )
          this.selected = []
          this.fetch()
        } catch (err) {
          this.setError(err)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.my-schedule {
  .service-item {
    svg{
      width: 20px;
      height: 20px;
    }
  }
  .dates {
    font-size: 0.75em;
    // background: #3c88ff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    position: sticky;
    top: 0;
    z-index: 200;
    // color: #fff;
    .first {
      transform: rotate(180deg);
      svg {
        width: 20px;
        height: 20px;
      }
    }
    .prev {
      transform: rotate(90deg);
      svg {
        width: 20px;
        height: 20px;
      }
    }
    .next {
      transform: rotate(-90deg);
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "telemedicine": "ონლაინ",
      "visit": "კლინიკაში",
      "house_call": "გამოძახება"
  }
}
</i18n>
